<script setup lang="ts">
import { Head } from '@inertiajs/vue3'
import { library } from "@fortawesome/fontawesome-svg-core"
import { } from "@fal"
import { faCheckCircle, faTimesCircle } from "@fas"

import PageHeading from "@/Components/Headings/PageHeading.vue"
import { PageHeading as PageHeadingTS } from '@/types/PageHeading'
import Icon from '@/Components/Utils/Icon.vue'
import CountUp from 'vue-countup-v3'
import { useFormatCurrency } from '@/Composables/useFormatCurrency'
import { useFormatNumber } from '@/Composables/useFormatNumber'

library.add(faCheckCircle, faTimesCircle)

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

const props = defineProps<{
    pageHead?: PageHeadingTS
    title: string
    stats: {
        customers: {}
        brands: {}
        orders: {}
        revenue: {}

    }
}>()

</script>

<template>

    <Head :title="title" />
    <PageHeading :data="pageHead"></PageHeading>
    

    <div class="mx-8 mt-6 gap-x-6 gap-y-8 xl:gap-x-6 ">
        <div class="max-w-7xl w-full grid grid-cols-1 gap-x-2 gap-y-1.5 md:grid-cols-5">            
            <div class="first:bg-cyan-100 first:border-cyan-300 first:text-cyan-700 bg-gray-50 border border-gray-300 relative md:col-span-2 px-4 py-6 sm:px-6 lg:px-8 rounded ">
                <p class="text-sm/6 font-medium opacity-60">
                    Total Revenue
                    <FontAwesomeIcon v-tooltip="'Dari order yang terbuat'" icon='fal fa-info-circle' class='' fixed-width aria-hidden='true' />
                </p>
                <p class="mt-2 flex flex-wrap items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight tabular-nums">
                        <CountUp :endVal='stats.revenue.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatCurrency(value)
                        }' />
                    </span>
                    <span v-if="stats.revenue.unit" class="opacity-70">+{{ useFormatCurrency(stats.revenue.unit) }} bulan ini</span>
                    <!-- <Icon v-if="stat.icon" :data="stat.icon" class="top-6 right-3 absolute opacity-70 text-2xl" /> -->
                </p>
            </div>

            <div class="relative px-4 py-6 sm:px-6 lg:px-8 rounded border border-gray-200">
                <p class="text-sm/6 font-medium text-gray-400">Total Customers</p>
                <p class="mt-2 flex flex-wrap items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats.customers.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                    <span class="text-green-500">{{ stats.customers.unit }}</span>
                    <!-- <Icon v-if="stat.icon" :data="stat.icon" class="top-6 right-3 absolute opacity-70 text-2xl" /> -->
                </p>
            </div>

            <div class="relative px-4 py-6 sm:px-6 lg:px-8 rounded border border-gray-200">
                <p class="text-sm/6 font-medium text-gray-400">Total Brands</p>
                <p class="mt-2 flex flex-wrap items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats.brands.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                    <span class="text-green-500">{{ stats.brands.unit }}</span>
                    <!-- <Icon v-if="stat.icon" :data="stat.icon" class="top-6 right-3 absolute opacity-70 text-2xl" /> -->
                </p>
            </div>

            <div class="relative px-4 py-6 sm:px-6 lg:px-8 rounded border border-gray-200">
                <p class="text-sm/6 font-medium text-gray-400">Total Orders</p>
                <p class="mt-2 flex flex-wrap items-baseline gap-x-2">
                    <span class="text-4xl font-semibold tracking-tight">
                        <CountUp :endVal='stats.orders.value' :duration='1.5' :scrollSpyOnce='true' :options='{
                            formattingFn: (value: number) => useFormatNumber(value)
                        }' />
                    </span>
                    <span class="text-green-500">{{ stats.orders.unit }}</span>
                    <!-- <Icon v-if="stat.icon" :data="stat.icon" class="top-6 right-3 absolute opacity-70 text-2xl" /> -->
                </p>
            </div>


        </div>
    </div>
</template>